<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.9673 2.17383L2.03271 18.1084M2.03271 2.17383L17.9673 18.1084" stroke="#D44944" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
